/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const StorePaymentType = {
    FORTE: 'FORTE',
    SENIM: 'SENIM',
    KASPI: 'KASPI',
    RAHMET: 'RAHMET',
    HALYK: 'HALYK',
    PAYBOX: 'PAYBOX',
    UZ_PAYBOX: 'UZ_PAYBOX',
    COIN: 'COIN',
    SQUAREUP: 'SQUAREUP'
} as const;
export type StorePaymentType = typeof StorePaymentType[keyof typeof StorePaymentType];

